import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductPublishEditor from '@/tiktok-platform/modules/products/ProductPublishEditor';

/**
 * TikTok 发品入口：布局与交互对齐 SHEIN ProductPublishEditor，
 * 底层类目 / 属性模板 / 提交参数走 Tiktok OpenAPI（bg.goods.*）。
 */
export default function ProductPublishWizardPage() {
  const [params] = useSearchParams();
  const draftId = params.get('draftId') || '';
  const productTemplateId = params.get('productTemplateId') || '';
  const fromProductTemplate = params.get('fromProductTemplate') || '';
  const referenceShopId = params.get('shopId') || '';
  return (
    <ProductPublishEditor
      mode="create"
      draftId={draftId}
      productTemplateId={productTemplateId}
      fromProductTemplate={fromProductTemplate}
      referenceShopId={referenceShopId}
    />
  );
}
